import { defineMessage } from 'services/localization';

export const messages = {
    transactionDetails: defineMessage('transaction_details'),
    date: defineMessage('date'),
    status: defineMessage('status_1'),
    source: defineMessage('source'),
    paymentDetails: defineMessage('payment_details'),
    total: defineMessage('total'),
    emptyContent: defineMessage('no_transactions_were_initiated_yet'),
    billsFrom: defineMessage('bills_from_contactname'),
    paymentIsScheduled: defineMessage('payment_is_scheduled_on_date'),
};
